/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'user': {
    width: 40,
    height: 40,
    viewBox: '0 0 40 40',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M20.167 6a5 5 0 100 10 5 5 0 000-10zm-7 5a7 7 0 1114 0 7 7 0 01-14 0zM16.154 26C13.38 26 11 28.46 11 31.667V35a1 1 0 11-2 0v-3.333C9 27.509 12.129 24 16.154 24h7.692C27.871 24 31 27.51 31 31.667V35a1 1 0 11-2 0v-3.333C29 28.46 26.619 26 23.846 26h-7.692z" _fill="#1F222C"/>'
  }
})
